__turbopack_context__.v({
  "detailsContainer": "TeamGridView-module-scss-module__ImvHTW__detailsContainer",
  "embla": "TeamGridView-module-scss-module__ImvHTW__embla",
  "emblaButton": "TeamGridView-module-scss-module__ImvHTW__emblaButton",
  "emblaButtonCarousel": "TeamGridView-module-scss-module__ImvHTW__emblaButtonCarousel",
  "emblaButtonNext": "TeamGridView-module-scss-module__ImvHTW__emblaButtonNext",
  "emblaButtonPrev": "TeamGridView-module-scss-module__ImvHTW__emblaButtonPrev",
  "emblaContainer": "TeamGridView-module-scss-module__ImvHTW__emblaContainer",
  "emblaContainerCnt": "TeamGridView-module-scss-module__ImvHTW__emblaContainerCnt",
  "emblaDash": "TeamGridView-module-scss-module__ImvHTW__emblaDash",
  "emblaDashes": "TeamGridView-module-scss-module__ImvHTW__emblaDashes",
  "emblaImg": "TeamGridView-module-scss-module__ImvHTW__emblaImg",
  "emblaSlide": "TeamGridView-module-scss-module__ImvHTW__emblaSlide",
  "emblaSlideContainer": "TeamGridView-module-scss-module__ImvHTW__emblaSlideContainer",
  "emblaViewport": "TeamGridView-module-scss-module__ImvHTW__emblaViewport",
  "grid": "TeamGridView-module-scss-module__ImvHTW__grid",
  "hideName": "TeamGridView-module-scss-module__ImvHTW__hideName",
  "hideTooltip": "TeamGridView-module-scss-module__ImvHTW__hideTooltip",
  "highlighted": "TeamGridView-module-scss-module__ImvHTW__highlighted",
  "hoverableName": "TeamGridView-module-scss-module__ImvHTW__hoverableName",
  "profileContainer": "TeamGridView-module-scss-module__ImvHTW__profileContainer",
  "profileImage": "TeamGridView-module-scss-module__ImvHTW__profileImage",
  "tagsContainer": "TeamGridView-module-scss-module__ImvHTW__tagsContainer",
  "tagsDesc": "TeamGridView-module-scss-module__ImvHTW__tagsDesc",
  "tagsMob": "TeamGridView-module-scss-module__ImvHTW__tagsMob",
  "teamDesc": "TeamGridView-module-scss-module__ImvHTW__teamDesc",
  "teamDetail": "TeamGridView-module-scss-module__ImvHTW__teamDetail",
  "teamName": "TeamGridView-module-scss-module__ImvHTW__teamName",
  "tooltip": "TeamGridView-module-scss-module__ImvHTW__tooltip",
});
